import type * as React from 'react';

export function NessoLogo({ className, ...props }: React.SVGProps<SVGSVGElement>) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={40}
            height={40}
            viewBox="0 0 40 40"
            fill="none"
            className={className}
            {...props}
        >
            <rect width="40" height="40" rx="6" fill="var(--primary)" />
            <path
                d="M24.2492 11.1096C25.3237 11.6821 26.1765 12.5612 26.8051 13.7446C27.4361 14.9279 27.7504 16.3842 27.7504 18.1137V29.7217H24.5562V18.1424C24.5562 16.813 24.3345 15.6393 23.8886 14.6189C23.4452 13.5984 22.8141 12.7984 22.0004 12.2163C21.1866 11.6342 20.2412 11.342 19.1668 11.342C17.5928 11.342 16.4501 11.8642 15.7362 12.9134C15.0223 13.9601 14.6666 15.2944 14.6666 16.9136C14.6666 17.8957 14.7641 19.2802 14.959 21.0648C15.1539 22.8494 15.4731 25.307 15.9165 28.4377C15.9726 28.821 15.8897 29.1396 15.6656 29.3935C15.4438 29.6474 15.1368 29.7672 14.7494 29.748L12.2496 29.7217L12.6663 18.3053C12.7394 16.6837 13.1341 15.2632 13.848 14.044C14.5618 12.8247 15.5096 11.8857 16.6962 11.2318C17.8803 10.5779 19.1936 10.2497 20.6384 10.2497C21.9711 10.2497 23.1747 10.5372 24.2492 11.1096Z"
                fill="var(--foreground)"
            />
        </svg>
    );
}
